<template>
  <div class="page">
    <div class="flex-align-center">
      <div class="card" style="width: 290px; margin-right: 20px">
        <div class="flex-between" style="margin-bottom: 10px">
          <span class="title-2">共{{ baseArr.length }}个测评</span>
        </div>
        <div class="ques-list">
          <div
            v-for="(item, index) in quesList"
            :key="index"
            :class="{
              'ques-item': true,
              'ques-active': index == topicActiveKey,
            }"
          >
            <div style="width: 230px" class="text-ellipsis-1">{{ item.title }}</div>
            <a-icon
              v-if="index < topicActiveKey"
              type="check-circle"
              :style="{ fontSize: '25px', color: '#1783e8' }"
            />
            <div v-else class="no-check"></div>
          </div>
        </div>
      </div>
      <div class="card" style="flex: 1">
        <EvalPreview
          v-if="showComStatus"
          :showHeader="false"
          :activeKey="topicActiveKey"
          :topicObj="topicObj"
          :remindStatus="showRemindStatus"
          :radioDisabled="false"
          :previewEvalData="currEval"
          ref="evalPreview"
          @changeRadioGroup="changeRadioGroup"
          @topicStatusChange="onTopicStatusChange"
        />
        <div class="submit-wrap">
          <!-- 题目加载完成前不显示提交按钮，防止加载间隙误提交 -->
          <template v-if="canSubmit">
            <a-button
              class="submit"
              :loading="btnLoading"
              type="primary"
              size="large"
              @click.stop="submitEvaluate"
            >
              提交测评
              <span v-if="quesList.length > 1">（{{ topicActiveKey + 1 }}）</span>
            </a-button>
          </template>
          <div v-else class="submit-tip">{{ topicTip }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EvalPreview from '@/comUi/EvalPreview'
import { TOPIC_RECORD } from '@/store/mutation-types'
import Vue from 'vue'
import { getNowTime } from '@/utils/util'
import { postAction } from '@api/manage'

export default {
  name: 'TeacherGrowth',
  components: {
    EvalPreview,
  },
  data() {
    return {
      quesList: [],
      topicActiveKey: Vue.ls.get(TOPIC_RECORD)?.activeKey || 0,
      topicObj: Vue.ls.get(TOPIC_RECORD) || { activeKey: this.topicActiveKey },
      showRemindStatus: false,
      currEval: {},
      queryObj: {},
      showComStatus: false,
      speedTime: 0,
      btnLoading: false,
      // 当前测评题目加载状态，初始为 loading，保证题目就绪前无法提交
      topicStatus: 'loading',
    }
  },
  computed: {
    // 题目加载完成前禁止提交
    canSubmit() {
      return this.topicStatus === 'ready'
    },
    topicTip() {
      if (this.topicStatus === 'loading' || this.topicStatus === '') {
        return '题目加载中，请稍候…'
      }
      if (this.topicStatus === 'error') {
        return '题目加载失败，请刷新页面重试'
      }
      if (this.topicStatus === 'empty') {
        return '该测评暂无可答题目，无法提交'
      }
      return ''
    },
  },
  props: {
    baseArr: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    baseArr: {
      handler(val) {
        console.log('baseArr:', val)
        this.showComStatus = false
        this.$nextTick(() => {
          this.showComStatus = true
        })
        if (!val.length) return
        this.quesList = val.map((item) => ({ ...item, title: item.name }))
        this.currEval = this.quesList[this.topicActiveKey]
        // this.getTopicList()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.queryObj = Vue.ls.get(TOPIC_RECORD)?.queryRecord || {}
    this.speedTime = getNowTime()
  },
  methods: {
    onTopicStatusChange(status) {
      this.topicStatus = status
    },
    async submitEvaluate() {
      // 兜底：题目未加载完成/无题/加载失败时禁止提交，防止空答案入库
      if (!this.canSubmit) {
        this.$message.warn(this.topicTip)
        return
      }
      const { dataSource, topicStoreArr } = this.$refs.evalPreview
      if (dataSource.length != topicStoreArr.filter((item) => item).length) {
        this.scroolView(topicStoreArr)
        this.$message.warn('请填写所有题目之后再提交')
        this.showRemindStatus = true
        return
      }
      this.showRemindStatus = false
      const stuData = Vue.ls.get(TOPIC_RECORD)?.stuData
      console.log('提交测评数据：', Vue.ls.get(TOPIC_RECORD)?.[this.topicActiveKey])

      const schoolEvaluationDetailList =
        Vue.ls.get(TOPIC_RECORD)?.[this.topicActiveKey]?.map((item) => ({
          questionId: item.split(',')[0],
          optionsId: item.split(',')[1],
          score: Number(item.split(',')[2]),
        })) || []

      const speedTime = getNowTime() - this.speedTime
      console.log('this.queryObj', this.queryObj)
      const paramsData = {
        planId: this.queryObj.id,
        evaluationId: this.currEval.id,
        schoolEvaluationDetailList,
        speedTime,
        ...stuData,
      }
      this.btnLoading = true
      const res = await postAction('/schoolEvaluationRecord/add', paramsData)
      if (res.success) {
        this.$message.success(res.message)
        this.speedTime = getNowTime()
        this.btnLoading = false
      } else {
        this.$message.error(res.message)
        this.btnLoading = false
        return
      }
      if (this.quesList.length - 1 == this.topicActiveKey) {
        this.$emit('submitEvaluate')
        Vue.ls.remove(TOPIC_RECORD)
        return
      }
      this.topicActiveKey = this.topicActiveKey + 1
      this.currEval = this.quesList[this.topicActiveKey]
      Vue.ls.set(TOPIC_RECORD, { ...this.topicObj, activeKey: this.topicActiveKey })
    },
    scroolView(topicStoreArr) {
      const evalPreviewElement = this.$refs.evalPreview
      const firstNullIndex =
        topicStoreArr.findIndex((item) => !item) > 0
          ? topicStoreArr.findIndex((item) => !item)
          : topicStoreArr.length

      const firstNullTopicRef = evalPreviewElement.$refs[`topicRef`][firstNullIndex]
      // const height = evalPreviewElement.$el.clientHeight
      // const firstNullTopicRect = firstNullTopicRef.getBoundingClientRect()
      firstNullTopicRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    changeRadioGroup(obj) {
      console.log('changeRadioGroup:', obj)
      this.topicObj = { ...this.topicObj, ...obj }
      Vue.ls.set(TOPIC_RECORD, this.topicObj)
    },
  },
}
</script>
<style scoped lang="less">
.page {
  padding: 10px;
}
.ques-list {
  .ques-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px;
    margin-bottom: 15px;
    border-radius: 6px;
    font-size: 16px;

    //&:hover {
    //  background-color: #eaf5ff;
    //  cursor: pointer;
    //}
  }
  .no-check {
    width: 26px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #dfe0e0;
  }
  .ques-active {
    background-color: #eaf5ff;
    color: #1783e8;
  }
}
.card {
  position: relative;
  box-sizing: border-box;
  height: 90vh;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
}
.submit-wrap {
  position: absolute;
  left: 50%;
  bottom: 4px;
  transform: translateX(-50%);
  text-align: center;
  .submit-tip {
    margin-bottom: 6px;
    color: #faad14;
    font-size: 12px;
    white-space: nowrap;
  }
  .submit {
    width: 160px;
  }
}
.page-header {
  height: 20px;
  padding-left: 0;
  cursor: pointer;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}
</style>
